import React from "react";

const Check = React.forwardRef(
  (
    {
      width = "12",
      height = "12",
      viewBox = "0 0 12 12",
      fill = "none",
      strokeColor = "#17B26A",
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 3L4.5 8.5L2 6"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default Check;
